// extracted by mini-css-extract-plugin
export default {"row":"TnSnapbox_row__ywrMj","image":"TnSnapbox_image__pqfNl","snapbox-balance":"TnSnapbox_snapbox-balance__WEoHx","button":"TnSnapbox_button__SqMB+","top":"TnSnapbox_top__N+WHS"};